import React from 'react'
import Video from '../Video/Video'

const Games = () => {
  return (
   
      <Video/>
    
  )
}

export default Games